import { request } from '../utils/request';

export const getUpsellPages = params =>
  request.get('/admin/upsell-pages', { params });

export const updateUpsellPages = data =>
  request.put(`/admin/upsell-pages`, data);
